export const getTypingTextForSession = (sessionId, sessionTypingMap, currentUserId, videographerId, clientId, videographerName, clientName) => {
  const sessionTypers = sessionTypingMap[sessionId];
  if (!sessionTypers) return null;

  const someoneElseTyping = Object.keys(sessionTypers).some(id => id !== currentUserId);
  const typistsName = Object.keys(sessionTypers)
    .filter(id => id !== currentUserId)
    .map(id => {
      if (id === videographerId) return videographerName;
      if (id === clientId) return clientName;
      return "Someone";
    })
    .join(", ");
    const typistsFirstName = typistsName.split(" ")[0];
  return someoneElseTyping ? `${typistsFirstName} is typing...` : null;
};
